import { render, staticRenderFns } from "./Prelude.vue?vue&type=template&id=215902be&"
import script from "./Prelude.vue?vue&type=script&lang=js&"
export * from "./Prelude.vue?vue&type=script&lang=js&"
import style0 from "./Prelude.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports